import { AuthenticationPayload, AuthenticationToken } from '@frontend/shared';

import { post } from '../base';

export function authenticate(params: AuthenticationPayload): Promise<AuthenticationToken> {
  return post('v4/auth', { json: { ...params } }).json();
}
